import useTranslation from "next-translate/useTranslation";
import React from "react";
import SegmentedControl from "../ui/segmented-control";

export default function DailyOptions({
  turnLength,
  setTurnLength,
  // variantId,
  // setVariantId,
  styles,
}) {
  const { t } = useTranslation("common");
  return (
    <>
      <div className="mt-5">
        <label className={styles.label}>{t("Time per move")}</label>
        <SegmentedControl
          options={[
            t("days", { count: 1 }),
            t("days", { count: 2 }),
            t("days", { count: 3 }),
          ]}
          numbersAsOptions={true}
          startNumber={1}
          selected={turnLength}
          setSelected={setTurnLength}
          selectedBgColor="bg-white"
          selectedTextColor="text-altgray-700"
          unselectedBgColor="bg-altgray-200"
          unselectedTextColor="text-altgray-700"
          customClassNameOuterDiv="border-4 rounded-md border-altgray-200 bg-altgray-200"
          customClassNameInnerDiv="p-1 rounded-md shadow-xl"
        />
      </div>
    </>
  );
}


